export const state = {
  retail: [],
  wholesale: [],
  retailUrl: [],
  wholesaleUrl: [],
}
